import { render, staticRenderFns } from "./BaseLangbar.vue?vue&type=template&id=03494a0f&scoped=true&"
import script from "./BaseLangbar.vue?vue&type=script&lang=js&"
export * from "./BaseLangbar.vue?vue&type=script&lang=js&"
import style0 from "./BaseLangbar.vue?vue&type=style&index=0&id=03494a0f&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "03494a0f",
  null
  
)

export default component.exports